import React from "react";

const getViewBox = name => {
  switch (name) {
    case "Facebook":
      return "0 0 28 28";
    case "Instagram":
      return "0 0 28 28";
    case "Twitter":
      return "0 0 1200 1227";
    case "YouTube":
      return "0 0 30 21";
    case "LinkedIn":
      return "0 0 28 28";
    default:
      return "0 0 28 28";
  }
};

const getPath = (name, props) => {
  switch (name) {
    case "Facebook":
      return (
        <path
          {...props}
          clipRule="evenodd"
          fillRule="evenodd"
          d="M3.33329 0.666664H24.6666C26.1394 0.666664 27.3333 1.86057 27.3333 3.33333V24.6667C27.3333 26.1394 26.1394 27.3333 24.6666 27.3333H3.33329C1.86053 27.3333 0.666626 26.1394 0.666626 24.6667V3.33333C0.666626 1.86057 1.86053 0.666664 3.33329 0.666664ZM3.33329 3.33333V24.6667H24.6666V3.33333H3.33329ZM12.844 14.0059H15.3333V22H18V14.0059H20.6432V11.3392H18V10C18 9.26362 18.5969 8.66666 19.3333 8.66666H20.6666V6H19.3333C17.1242 6 15.3333 7.79086 15.3333 10V11.3392H12.844V14.0059Z"
        />
      );
    case "Instagram":
      return (
        <path
          {...props}
          clipRule="evenodd"
          fillRule="evenodd"
          d="M19.3333 0.666664H8.66663C4.24835 0.666664 0.666626 4.24839 0.666626 8.66666V19.3333C0.666626 23.7516 4.24835 27.3333 8.66663 27.3333H19.3333C23.7516 27.3333 27.3333 23.7516 27.3333 19.3333V8.66666C27.3333 4.24839 23.7516 0.666664 19.3333 0.666664ZM3.33329 8.66666C3.33329 5.72115 5.72111 3.33333 8.66663 3.33333H19.3333C22.2788 3.33333 24.6666 5.72115 24.6666 8.66666V19.3333C24.6666 22.2788 22.2788 24.6667 19.3333 24.6667H8.66663C5.72111 24.6667 3.33329 22.2788 3.33329 19.3333V8.66666ZM14 20.6667C10.3181 20.6667 7.33329 17.6819 7.33329 14C7.33329 10.3181 10.3181 7.33333 14 7.33333C17.6819 7.33333 20.6666 10.3181 20.6666 14C20.6666 17.6819 17.6819 20.6667 14 20.6667ZM14 18C16.2091 18 18 16.2091 18 14C18 11.7909 16.2091 10 14 10C11.7908 10 9.99996 11.7909 9.99996 14C9.99996 16.2091 11.7908 18 14 18ZM22 7.33333C22 8.06971 21.403 8.66666 20.6666 8.66666C19.9302 8.66666 19.3333 8.06971 19.3333 7.33333C19.3333 6.59695 19.9302 6 20.6666 6C21.403 6 22 6.59695 22 7.33333Z"
        />
      );
    case "Twitter":
      return (
        <path
          {...props}
          clipRule="evenodd"
          fillRule="evenodd"
          d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" 
        />
      );
    case "YouTube":
      return (
        <path
          {...props}
          clipRule="evenodd"
          fillRule="evenodd"
          d="M28.3664 19.1709C29.2774 17.6095 29.6667 15.0918 29.6667 10.9963C29.6667 6.91704 29.2811 4.41398 28.3603 2.81071C27.4375 1.14582 26.3431 0.617378 24.1711 0.490537C22.6883 0.390032 19.0031 0.333336 15.0036 0.333336C10.9955 0.333336 7.30863 0.390011 5.81471 0.491325C3.65486 0.61768 2.56019 1.14729 1.62928 2.8168C0.721886 4.41454 0.333374 6.92983 0.333374 11.0112C0.333374 15.0694 0.723767 17.5973 1.63726 19.1898C2.55606 20.8378 3.63328 21.3611 5.81151 21.5141C7.37705 21.6057 11.2726 21.6667 15.0036 21.6667C18.7262 21.6667 22.6199 21.6057 24.1711 21.5151C26.3694 21.3611 27.4464 20.837 28.3664 19.1709ZM24.0033 3.15189C25.3619 3.23129 25.6138 3.3534 26.0445 4.13285C26.6714 5.21866 27 7.34362 27 11.0112C27 14.651 26.6697 16.7877 26.0474 17.8547C25.6153 18.6365 25.3651 18.7583 24.0002 18.8539C22.5319 18.9396 18.676 19 15.0036 19C11.3229 19 7.46503 18.9396 5.98275 18.8529C4.63472 18.7582 4.38091 18.6349 3.95835 17.8771C3.33186 16.7847 3.00004 14.6361 3.00004 10.9963C3.00004 7.35865 3.33009 5.22185 3.95324 4.12456C4.38237 3.35503 4.63796 3.23137 5.98283 3.15266C7.40681 3.05614 11.059 3 15.0036 3C18.9397 3 22.5902 3.05616 24.0033 3.15189ZM12.3334 7L19 11L12.3334 15V7Z"
        />
      );
    case "LinkedIn":
      return (
        <path
          {...props}
          clipRule="evenodd"
          fillRule="evenodd"
          d="M3.33341 0.666656H24.6667C26.1395 0.666656 27.3334 1.86056 27.3334 3.33332V24.6667C27.3334 26.1394 26.1395 27.3333 24.6667 27.3333H3.33341C1.86066 27.3333 0.666748 26.1394 0.666748 24.6667V3.33332C0.666748 1.86056 1.86066 0.666656 3.33341 0.666656ZM3.33341 3.33332V24.6667H24.6667V3.33332H3.33341ZM15.3334 9.99999C14.6431 9.99999 13.9137 10.211 13.2696 10.6029L12.6667 9.99999H11.3334V19.3333H14.0001V14C14.0001 13.2323 14.792 12.6667 15.3334 12.6667H16.6667C17.2081 12.6667 18.0001 13.2323 18.0001 14V19.3333H20.6667V14C20.6667 11.5296 18.5254 9.99999 16.6667 9.99999H15.3334ZM8.66675 8.66666C9.40313 8.66666 10.0001 8.0697 10.0001 7.33332C10.0001 6.59694 9.40313 5.99999 8.66675 5.99999C7.93037 5.99999 7.33341 6.59694 7.33341 7.33332C7.33341 8.0697 7.93037 8.66666 8.66675 8.66666ZM7.33341 9.99999V19.3333H10.0001V9.99999H7.33341Z"
        />
      );
    case "Tiktok":
      return (
        <path
          {...props}
          clipRule="evenodd"
          fillRule="evenodd"
          d="M3.3,0.7h21.3c1.5,0,2.7,1.2,2.7,2.7v21.3c0,1.5-1.2,2.7-2.7,2.7H3.3c-1.5,0-2.7-1.2-2.7-2.7V3.3
          C0.7,1.9,1.9,0.7,3.3,0.7z M3.3,3.3v21.3h21.3V3.3H3.3z M20.8,12.5c-0.1,0-0.3,0-0.4,0c-1.4,0-2.8-0.7-3.6-1.9v6.6
          c0,2.7-2.2,4.9-4.9,4.9c-2.7,0-4.9-2.2-4.9-4.9c0-2.7,2.2-4.9,4.9-4.9l0,0c0.1,0,0.2,0,0.3,0v2.4c-0.1,0-0.2,0-0.3,0
          c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5c1.4,0,2.6-1.1,2.6-2.5l0-11.2h2.3c0.2,2.1,1.9,3.7,3.9,3.8L20.8,12.5"
        />
      );
    default:
      return <path />;
  }
};

const SocialMedia = ({
  name = "",
  style = {},
  fill = "#fff",
  viewBox = "",
  width = "28",
  className = "",
  height = "28"
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox || getViewBox(name)}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    {getPath(name, { fill })}
  </svg>
);

export default SocialMedia;
